// API refresh responses identify the product in `id`; their `uuid` can belong
// to the form/presentation payload. Keep route identity consistent with bidding.
const getPublicProductIdentifier = (product, fallbackIdentifier = null) =>
    [product?.id, fallbackIdentifier, product?.uuid, product?.productUuid]
        .find(value => typeof value === 'string' && value.trim().length > 0) ?? null;

const getPublicProductRouteIdentifier = (product, fallbackIdentifier = null) =>
    getPublicProductIdentifier(product, fallbackIdentifier);

module.exports = {getPublicProductIdentifier, getPublicProductRouteIdentifier};
